import { Inject, Injectable, Injector } from '@angular/core';

import { FootprintEdi_FlowService } from './FootprintEdi.flow.index';

import { app_edi_export_completed_shipmentsService } from './app.flow.index';
import { app_edi_export_inventory_snapshotService } from './app.flow.index';
import { app_edi_set_wavelength_connector_transmissionService } from './app.flow.index';
import { app_edi_sftp_pull_and_submitService } from './app.flow.index';
import { app_edi_sftp_pushService } from './app.flow.index';
import { app_edi_submit_entity_import_xml_requestService } from './app.flow.index';
import { app_rabbit_mq_pushService } from './app.flow.index';
import { app_sftp_pullService } from './app.flow.index';
import { app_sftp_pull_and_submitService } from './app.flow.index';
import { app_sftp_pushService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.FootprintEdi = this.injector.get(FootprintEdi_FlowService);
  }

    public FootprintEdi: FootprintEdi_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _edi_export_completed_shipments: app_edi_export_completed_shipmentsService;
  public async edi_export_completed_shipments($inParams: { project_ids?: number[], days?: number, shipment_type?: number, transaction_type?: string, integration_id: string, has_order_transmissions?: boolean }): Promise<void> {
    if(!this._edi_export_completed_shipments) { 
      this._edi_export_completed_shipments = this.injector.get(app_edi_export_completed_shipmentsService);
    }
    return this._edi_export_completed_shipments.run($inParams);
  }
   
   

   
 
  private _edi_export_inventory_snapshot: app_edi_export_inventory_snapshotService;
  public async edi_export_inventory_snapshot($inParams: { owner_lookup?: string, project_lookup: string, integration_id: string, transaction_type: string, transaction_id?: string, render_options?: { lots?: boolean, license_plates?: boolean, serial_numbers?: boolean, only_inventory?: boolean, only_physical?: boolean, date_format?: string } }): Promise< { messages?: any[] }> {
    if(!this._edi_export_inventory_snapshot) { 
      this._edi_export_inventory_snapshot = this.injector.get(app_edi_export_inventory_snapshotService);
    }
    return this._edi_export_inventory_snapshot.run($inParams);
  }
   
   

   
 
  private _edi_set_wavelength_connector_transmission: app_edi_set_wavelength_connector_transmissionService;
  public async edi_set_wavelength_connector_transmission($inParams: { shipment_id?: number, integration_id: string, transaction_id: string, transaction_type?: string, file_content: string }): Promise<void> {
    if(!this._edi_set_wavelength_connector_transmission) { 
      this._edi_set_wavelength_connector_transmission = this.injector.get(app_edi_set_wavelength_connector_transmissionService);
    }
    return this._edi_set_wavelength_connector_transmission.run($inParams);
  }
   
   

   
 
  private _edi_sftp_pull_and_submit: app_edi_sftp_pull_and_submitService;
  public async edi_sftp_pull_and_submit($inParams: { integration_id: string, sftp_connection: string, sftp_path: string, sftp_extension?: string, mq_connection?: string }): Promise<void> {
    if(!this._edi_sftp_pull_and_submit) { 
      this._edi_sftp_pull_and_submit = this.injector.get(app_edi_sftp_pull_and_submitService);
    }
    return this._edi_sftp_pull_and_submit.run($inParams);
  }
   
   

   
 
  private _edi_sftp_push: app_edi_sftp_pushService;
  public async edi_sftp_push($inParams: { integration_id: string, file_content: string, transaction_type?: string }): Promise<void> {
    if(!this._edi_sftp_push) { 
      this._edi_sftp_push = this.injector.get(app_edi_sftp_pushService);
    }
    return this._edi_sftp_push.run($inParams);
  }
   
   

   
 
  private _edi_submit_entity_import_xml_request: app_edi_submit_entity_import_xml_requestService;
  public async edi_submit_entity_import_xml_request($inParams: { integration_id?: string, entity_import_content?: string }): Promise< { request_id?: string }> {
    if(!this._edi_submit_entity_import_xml_request) { 
      this._edi_submit_entity_import_xml_request = this.injector.get(app_edi_submit_entity_import_xml_requestService);
    }
    return this._edi_submit_entity_import_xml_request.run($inParams);
  }
   
   

   
 
  private _rabbit_mq_push: app_rabbit_mq_pushService;
  public async rabbit_mq_push($inParams: { egress_id?: string, transaction_id?: string, integration_id?: string, connection?: string, exchange?: string, contract?: string, message?: { Payload?: string, TransactionSet?: string, InboundTransactionId?: string, OutboundTransactionId?: string, Content?: string } }): Promise< { messages?: any[], success?: boolean }> {
    if(!this._rabbit_mq_push) { 
      this._rabbit_mq_push = this.injector.get(app_rabbit_mq_pushService);
    }
    return this._rabbit_mq_push.run($inParams);
  }
   
   

   
 
  private _sftp_pull: app_sftp_pullService;
  public async sftp_pull($inParams: { connection: string, source_path: string, archive_path?: string, error_path?: string, file_extension?: string, file_name?: string, sort_asc?: boolean, transaction_id?: string }): Promise< { messages?: any[], success?: boolean, files?: { file_name?: string, file_blob?: any }[] }> {
    if(!this._sftp_pull) { 
      this._sftp_pull = this.injector.get(app_sftp_pullService);
    }
    return this._sftp_pull.run($inParams);
  }
   
   

   
 
  private _sftp_pull_and_submit: app_sftp_pull_and_submitService;
  public async sftp_pull_and_submit($inParams: { integration_id: string, sftp_connection: string, sftp_path: string, sftp_extension?: string, mq_connection?: string }): Promise< { messages?: any[] }> {
    if(!this._sftp_pull_and_submit) { 
      this._sftp_pull_and_submit = this.injector.get(app_sftp_pull_and_submitService);
    }
    return this._sftp_pull_and_submit.run($inParams);
  }
   
   

   
 
  private _sftp_push: app_sftp_pushService;
  public async sftp_push($inParams: { connection: string, target_path: string, file_content: string, transaction_type?: string }): Promise< { messages?: any[], success?: boolean }> {
    if(!this._sftp_push) { 
      this._sftp_push = this.injector.get(app_sftp_pushService);
    }
    return this._sftp_push.run($inParams);
  }
   
   

   
}
